import {
  ApButtonMain,
  ApButtonSecondary,
  ApIcon,
  colors,
} from '@alixpartners/ui-components';
import styled from 'styled-components';

export const UploadIcon = styled(ApIcon)`
  margin: 64px auto 0;
  color: ${colors.grey3};
`;

export const UploadTileDragText = styled.div`
  color: ${colors.grey5};
  font-size: 13px;
  letter-spacing: 0.3px;
  font-weight: 400;
`;

export const AddFileSecondaryButton = styled(ApButtonSecondary)`
  margin-top: 32px;
  margin-bottom: 32px;
  padding: 8px;
`;

export const AddFilePrimaryButton = styled(ApButtonMain)`
  margin-top: 32px;
  margin-bottom: 32px;
  padding: 8px;
`;

export const UploadWrapper = styled.div<{ isDragActive: boolean }>`
  width: 516px;
  height: 270px;
  border: ${(props) =>
    props.isDragActive
      ? `1px solid ${colors.grey7}`
      : `1px dashed ${colors.grey4}`};
  background-color: ${colors.white};
  margin: 16px auto 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
